// extracted by mini-css-extract-plugin
export default {"checksOfTimeToGet":"TimeAndDateSelctionPop_checksOfTimeToGet__uFFv1","checksOTChekcs":"TimeAndDateSelctionPop_checksOTChekcs__igEYV"};